import { render, staticRenderFns } from "./DragSignOffice.vue?vue&type=template&id=0293be4a&scoped=true&"
import script from "./DragSignOffice.vue?vue&type=script&lang=js&"
export * from "./DragSignOffice.vue?vue&type=script&lang=js&"
import style0 from "./DragSignOffice.vue?vue&type=style&index=0&id=0293be4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0293be4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0293be4a')) {
      api.createRecord('0293be4a', component.options)
    } else {
      api.reload('0293be4a', component.options)
    }
    module.hot.accept("./DragSignOffice.vue?vue&type=template&id=0293be4a&scoped=true&", function () {
      api.rerender('0293be4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/DragSignOffice.vue"
export default component.exports